"use client";

import { Icon } from "@iconify/react";

// Icônes pixel-art (collection pixelarticons, MIT) : réservées aux icônes
// d'identité des offres (Plus / Pro / Founder). Les icônes fonctionnelles
// restent sur la collection Solar via SolarIcon.
export default function PixelIcon({ name, className, style }) {
    return (
        <Icon
            icon={`pixelarticons:${name}`}
            className={className}
            style={style}
            aria-hidden="true"
        />
    );
}
